import { render, staticRenderFns } from "./WidgetEscalations.vue?vue&type=template&id=eb8cf1ec&scoped=true&"
import script from "./WidgetEscalations.vue?vue&type=script&lang=js&"
export * from "./WidgetEscalations.vue?vue&type=script&lang=js&"
import style0 from "./WidgetEscalations.vue?vue&type=style&index=0&id=eb8cf1ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8cf1ec",
  null
  
)

export default component.exports